var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.52961 16.1221C9.268 15.4771 8.79028 14.9432 8.17828 14.6118C7.56628 14.2803 6.85808 14.172 6.17498 14.3053C5.49188 14.4386 4.87638 14.8053 4.43391 15.3425C3.99144 15.8797 3.74953 16.5541 3.74961 17.2501C3.74961 17.5582 3.68633 17.863 3.56369 18.1457C3.44105 18.4283 3.26167 18.6828 3.03665 18.8932C2.81164 19.1037 2.5458 19.2657 2.2556 19.3693C1.9654 19.4728 1.65703 19.5156 1.34961 19.4951C1.84406 20.354 2.60824 21.0257 3.52353 21.4059C4.43882 21.786 5.45401 21.8534 6.41151 21.5975C7.369 21.3416 8.21523 20.7767 8.81882 19.9906C9.42242 19.2045 9.74961 18.2412 9.74961 17.2501C9.74961 16.8511 9.67161 16.4701 9.52961 16.1221ZM9.52961 16.1221C10.7186 15.717 11.8558 15.1732 12.9176 14.5021M7.87461 14.4771C8.27982 13.2855 8.82425 12.146 9.49661 11.0821M12.9166 14.5021C14.813 13.3039 16.4361 11.7203 17.6806 9.85407L21.5566 4.04007C21.7051 3.81864 21.7721 3.55252 21.7462 3.28717C21.7203 3.02182 21.603 2.77369 21.4145 2.58517C21.226 2.39664 20.9779 2.27941 20.7125 2.2535C20.4472 2.22758 20.181 2.29459 19.9596 2.44307L14.1456 6.32007C12.2791 7.56421 10.6952 9.187 9.49661 11.0831C11.0185 11.7635 12.2361 12.9812 12.9166 14.5031",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.27442743b5f0ab334f572f79e0407887.svg";
export { ForwardRef as ReactComponent };